import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * A request in one table cell: its subject on top, the ID and workflow type under it.
 * Without a subject a grey "No subject" placeholder takes the first line.
 */
@Component({
  selector: 'lib-request-summary-cell',
  templateUrl: './request-summary-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe],
})
export class RequestSummaryCellComponent {
  readonly requestId = input<string | number | null>();
  readonly workflowType = input<string | null>();
  readonly subject = input<string | null>();

  protected readonly subjectText = computed(() => this.subject()?.trim());
}
